import { View } from "ui/atoms/view";
import { MedicationReportModel } from "../../../services/api/types/medications/models/MedicationReportModel";
import { useMemo, useRef } from "react";
import { GridItem } from "ui/types/GridItem";
import KeyValueGrid from "ui/organisms/KeyValueGrid";
import { getFullName } from "ui/utils/nameUtil";
import { Text } from "react-native";
import { format } from "date-fns";
import { MedicationItem } from "../organisms/MedicationItem";
import { ModifyMedicationLogModal } from "../modals/ModifyMedicationLogModal";

interface Props {
  medicationLog: MedicationReportModel;
}

export function MedicationLogContent({ medicationLog }: Props) {
  const ref = useRef<React.ComponentRef<typeof ModifyMedicationLogModal>>(null);
  const handleShowAddNoteOrVoidModal = () => {
    ref.current?.show(medicationLog);
  };

  const medicationLogDetails = useMemo<GridItem[]>(() => {
    return [
      {
        label: "Diagnosis",
        value: medicationLog?.medication.diagnosis || "N/A",
      },
      { label: "Status", value: medicationLog?.medication.status ?? "N/A" },
      {
        label: "Original note",
        value: medicationLog?.other_information || "N/A",
      },
      {
        label: "Skip reason",
        value: medicationLog?.skip_reason || "N/A",
      },
      {
        label: "Administrator",
        value: medicationLog?.administrator
          ? getFullName(medicationLog?.administrator)
          : "N/A",
      },
    ];
  }, [medicationLog]);
  return (
    <View className="flex flex-col gap-y-2">
      <ModifyMedicationLogModal ref={ref} />
      <MedicationItem
        medication={medicationLog?.medication}
        isViewing
        startAddNoteOrVoid={handleShowAddNoteOrVoidModal}
        medicationLogStatus={medicationLog.status}
      />
      <View className="rounded-xl border border-border-200 w-full px-9 py-10">
        <KeyValueGrid items={medicationLogDetails} />
        {(medicationLog?.post_submission_notes?.length ?? 0) > 0 && (
          <View>
            <View className="border-b border-gray-200 my-8" />
            <View className="gap-4">
              <Text className="text-md font-semibold">Notes</Text>
              {medicationLog?.post_submission_notes.map((note) => (
                <View key={note.id} className="gap-2">
                  <View className="grid grid-cols-1 sm:grid-cols-3 mb-4">
                    <View className="flex flex-col">
                      <Text className="text-gray-600 mb-3">Actioned by</Text>
                      <View className="gap-1">
                        <Text>{getFullName(note.user)} on</Text>
                        <Text>
                          {format(
                            new Date(note.created_at),
                            "dd-MM-yyyy 'at' HH:mm",
                          )}
                        </Text>
                      </View>
                    </View>

                    <View className="flex flex-col pl-4">
                      <Text className="text-gray-600 mb-3 mt-3 sm:mt-0">
                        Note
                      </Text>
                      <Text className="text-md">{note.note}</Text>
                    </View>
                  </View>
                </View>
              ))}
            </View>
          </View>
        )}
      </View>
    </View>
  );
}
